import cn from "classnames";

interface AbsoluteBackgroundProps {
  className?: string;
}

/* eslint-disable react-refresh/only-export-components */
export default ({ className }: AbsoluteBackgroundProps) => (
  <div
    className={cn("absolute inset-0 h-[calc(100*var(--vh,1svh))]", className)}
  />
);
